import { ReactNode } from 'react';
import { AdminStoreProvider } from './AdminStoreProvider';

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => <AdminStoreProvider>{children}</AdminStoreProvider>;
